import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
    {
        path: '/login',
        component: () => import('@/views/login/index'),
        hidden: true
    }, {
        path: '/404',
        component: () => import('@/views/404'),
        hidden: true
    }, {
        path: '',
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'home',
                component: () => import('@/views/home/index'),
                meta: {
                    title: '首页',
                    icon: 'home'
                }
            }
        ]
    }
]

export const asyncRouterMap = [
    {
        path: '/journal',
        component: Layout,
        redirect: '/journal/list',
        name: 'journal',
        meta: {
            title: '电子特辑',
            icon: 'journal'
        },
        children: [
            {
                path: 'list',
                name: 'journalList',
                component: () => import('@/views/journal/list'),
                meta: {
                    title: '电子特辑列表',
                    icon: 'journal'
                }
            }, {
                path: 'recycle',
                name: 'journalRecycle',
                component: () => import('@/views/journal/recycle'),
                meta: {
                    title: '回收站',
                    icon: 'journal'
                }
            }, {
                path: 'save',
                name: 'journalSave',
                component: () => import('@/views/journal/save'),
                meta: {
                    title: '添加电子特辑'
                },
                hidden: true
            }, {
                path: 'update',
                name: 'journalUpdate',
                component: () => import('@/views/journal/update'),
                meta: {
                    title: '修改电子特辑'
                },
                hidden: true
            }, {
                path: 'pageList',
                name: 'journalPageList',
                component: () => import('@/views/journal/pageList'),
                meta: {
                    title: '内容页列表'
                },
                hidden: true
            }, {
                path: 'pageEditor',
                name: 'journalPageEditor',
                component: () => import('@/views/journal/pageEditor'),
                meta: {
                    title: '编辑内容页'
                },
                hidden: true
            }, {
                path: 'subscriptionPlan',
                name: 'subscriptionPlan',
                component: () => import('@/views/journal/subscriptionPlan/list'),
                meta: {
                    title: '订阅套餐管理',
                    icon: 'subscription'
                }
            }, {
                path: 'subscriptionPlan/save',
                name: 'subscriptionPlanSave',
                component: () => import('@/views/journal/subscriptionPlan/save'),
                meta: {
                    title: '添加订阅套餐'
                },
                hidden: true
            }, {
                path: 'subscriptionPlan/update',
                name: 'subscriptionPlanUpdate',
                component: () => import('@/views/journal/subscriptionPlan/save'),
                meta: {
                    title: '修改订阅套餐'
                },
                hidden: true
            }, {
                path: 'subscriptionRecord',
                name: 'subscriptionRecord',
                component: () => import('@/views/journal/subscriptionRecord/list'),
                meta: {
                    title: '订阅记录',
                    icon: 'subscription-record'
                }
            }, {
                path: 'subscriptionRecord/detail',
                name: 'subscriptionRecordDetail',
                component: () => import('@/views/journal/subscriptionRecord/detail'),
                meta: {
                    title: '订阅记录详情'
                },
                hidden: true
            }, {
                path: 'purchaseRecord',
                name: 'purchaseRecord',
                component: () => import('@/views/journal/purchaseRecord/list'),
                meta: {
                    title: '购买记录',
                    icon: 'purchase-record'
                }
            }, {
                path: 'purchaseRecord/detail',
                name: 'purchaseRecordDetail',
                component: () => import('@/views/journal/purchaseRecord/detail'),
                meta: {
                    title: '购买记录详情'
                },
                hidden: true
            }, {
                path: 'redeemCode',
                name: 'redeemCode',
                component: () => import('@/views/journal/redeemCode/list'),
                meta: {
                    title: '兑换码管理',
                    icon: 'redeem-code'
                }
            }, {
                path: 'redeemCode/save',
                name: 'redeemCodeSave',
                component: () => import('@/views/journal/redeemCode/save'),
                meta: {
                    title: '添加兑换码'
                },
                hidden: true
            }, {
                path: 'redeemCode/update',
                name: 'redeemCodeUpdate',
                component: () => import('@/views/journal/redeemCode/save'),
                meta: {
                    title: '编辑兑换码'
                },
                hidden: true
            }, {
                path: 'redeemCode/useLog',
                name: 'redeemCodeUseLog',
                component: () => import('@/views/journal/redeemCode/useLog'),
                meta: {
                    title: '兑换码使用记录'
                },
                hidden: true
            }
        ]
    }, {
        path: '/news',
        component: Layout,
        redirect: '/news/article',
        name: 'news',
        meta: {
            title: '资讯',
            icon: 'form'
        },
        children: [
            {
                path: 'category',
                name: 'newsCategory',
                component: () => import('@/views/news/categoryList'),
                meta: {
                    title: '资讯分类',
                    icon: 'table'
                }
            },
            {
                path: 'article',
                name: 'newsArticle',
                component: () => import('@/views/news/articleList'),
                meta: {
                    title: '资讯列表',
                    icon: 'table'
                }
            },
            {
                path: 'comment',
                name: 'newsComment',
                component: () => import('@/views/news/commentList'),
                meta: {
                    title: '评论管理',
                    icon: 'table'
                }
            },
            {
                path: 'article/edit',
                name: 'newsArticleEdit',
                component: () => import('@/views/news/articleEdit'),
                meta: {
                    title: '编辑资讯'
                },
                hidden: true
            }
        ]
    }, {
        path: '/pms',
        component: Layout,
        redirect: '/pms/product',
        name: 'pms',
        meta: {
            title: '商品',
            icon: 'product'
        },
        children: [
            {
                path: 'productCate',
                name: 'productCate',
                component: () => import('@/views/pms/productCate/index'),
                meta: {
                    title: '商品分类',
                    icon: 'product-cate'
                }
            }, {
                path: 'addProductCate',
                name: 'addProductCate',
                component: () => import('@/views/pms/productCate/add'),
                meta: { title: '添加商品分类' },
                hidden: true
            }, {
                path: 'updateProductCate',
                name: 'updateProductCate',
                component: () => import('@/views/pms/productCate/update'),
                meta: { title: '修改商品分类' },
                hidden: true
            }, {
                path: 'productAttr',
                name: 'productAttr',
                component: () => import('@/views/pms/productAttr/index'),
                meta: {
                    title: '商品类型',
                    icon: 'product-attr'
                }
            }, {
                path: 'productAttrList',
                name: 'productAttrList',
                component: () => import('@/views/pms/productAttr/productAttrList'),
                meta: { title: '商品属性列表' },
                hidden: true
            }, {
                path: 'addProductAttr',
                name: 'addProductAttr',
                component: () => import('@/views/pms/productAttr/addProductAttr'),
                meta: { title: '添加商品属性' },
                hidden: true
            }, {
                path: 'updateProductAttr',
                name: 'updateProductAttr',
                component: () => import('@/views/pms/productAttr/updateProductAttr'),
                meta: { title: '修改商品属性' },
                hidden: true
            }, {
                path: 'brand',
                name: 'brand',
                component: () => import('@/views/pms/brand/index'),
                meta: {
                    title: '品牌管理',
                    icon: 'product-brand'
                }
            }, {
                path: 'addBrand',
                name: 'addBrand',
                component: () => import('@/views/pms/brand/add'),
                meta: { title: '添加品牌' },
                hidden: true
            }, {
                path: 'updateBrand',
                name: 'updateBrand',
                component: () => import('@/views/pms/brand/update'),
                meta: { title: '编辑品牌' },
                hidden: true
            }, {
                path: 'feight',
                name: 'feight',
                component: () => import('@/views/sms/feight/index'),
                meta: {
                    title: '运费模板',
                    icon: 'feight'
                },
                hidden: true
            }, {
                path: 'addFreightTemp',
                name: 'addFreightTemp',
                component: () => import('@/views/sms/feight/addFreightTemp'),
                meta: { title: '创建运费模板' },
                hidden: true
            }, {
                path: 'updateFeightTemp',
                name: 'updateFeightTemp',
                component: () => import('@/views/sms/feight/updateFeightTemp'),
                meta: { title: '编辑运费模板' },
                hidden: true
            }, {
                path: 'product',
                name: 'product',
                component: () => import('@/views/pms/product/index'),
                meta: {
                    title: '商品列表',
                    icon: 'product-list'
                }
            }, {
                path: 'addProduct',
                name: 'addProduct',
                component: () => import('@/views/pms/product/add'),
                meta: {
                    title: '添加商品',
                    icon: 'product-add'
                }
            }, {
                path: 'updateProduct',
                name: 'updateProduct',
                component: () => import('@/views/pms/product/update'),
                meta: {
                    title: '修改商品',
                    icon: 'product-add'
                },
                hidden: true
            }
        ]
    }, {
        path: '/oms',
        component: Layout,
        redirect: '/oms/order',
        name: 'oms',
        meta: {
            title: '订单',
            icon: 'order'
        },
        children: [
            {
                path: 'order',
                name: 'order',
                component: () => import('@/views/oms/order/index'),
                meta: {
                    title: '订单列表',
                    icon: 'product-list'
                }
            }, {
                path: 'orderDetail',
                name: 'orderDetail',
                component: () => import('@/views/oms/order/orderDetail'),
                meta: { title: '订单详情' },
                hidden: true
            }, {
                path: 'deliverOrderList',
                name: 'deliverOrderList',
                component: () => import('@/views/oms/order/deliverOrderList'),
                meta: { title: '发货列表' },
                hidden: true
            }, {
                path: 'orderSetting',
                name: 'orderSetting',
                component: () => import('@/views/oms/order/setting'),
                meta: {
                    title: '订单设置',
                    icon: 'order-setting'
                }
            }, {
                path: 'returnApply',
                name: 'returnApply',
                component: () => import('@/views/oms/apply/index'),
                meta: {
                    title: '退货申请处理',
                    icon: 'order-return'
                }
            }, {
                path: 'returnReason',
                name: 'returnReason',
                component: () => import('@/views/oms/apply/reason'),
                meta: {
                    title: '退货原因设置',
                    icon: 'order-return-reason'
                }
            }, {
                path: 'returnApplyDetail',
                name: 'returnApplyDetail',
                component: () => import('@/views/oms/apply/applyDetail'),
                meta: { title: '退货原因详情' },
                hidden: true
            }, {
                path: 'companyAddress',
                name: 'companyAddress',
                component: () => import('@/views/oms/refundAddress/index'),
                meta: {
                    title: '管理退货地址',
                    icon: 'order-return-reason'
                }
            }, {
                path: 'checkwxpay',
                name: 'checkwxpay',
                component: () => import('@/views/oms/order/checkwxpay'),
                hidden: true
            }, {
                path: 'batchshipment',
                name: 'batchshipment',
                component: () => import('@/views/oms/order/batchShipment'),
                hidden: true
            }
        ]
    }, {
        path: '/sms',
        component: Layout,
        redirect: '/sms/indexRecommend',
        name: 'sms',
        meta: {
            title: '设置',
            icon: 'sms'
        },
        alwaysShow: true,
        children: [
            {
                path: 'arenaIntroduce',
                name: 'arenaIntroduce',
                component: () => import('@/views/sms/setting/arenaIntroduceSet'),
                meta: { title: '品牌介绍图' },
                hidden: true
            }, {
                path: 'indexRecommend',
                name: 'indexRecommend',
                component: () => import('@/views/sms/setting/indexRecommend'),
                meta: {
                    title: '首页推荐',
                    icon: 'product-brand'
                },
                hidden: true
            }, {
                path: 'addIndexRecommend',
                name: 'addIndexRecommend',
                component: () => import('@/views/sms/setting/addIndexRecommend'),
                meta: { title: '添加首页推荐' },
                hidden: true
            }, {
                path: 'updateIndexRecommend',
                name: 'updateIndexRecommend',
                component: () => import('@/views/sms/setting/updateIndexRecommend'),
                meta: { title: '修改首页推荐' },
                hidden: true
            }, {
                path: 'searchSetting',
                name: 'searchSetting',
                component: () => import('@/views/sms/setting/searchSetting'),
                meta: {
                    title: '搜索设置',
                    icon: 'search-setting'
                },
                hidden: true
            } 
            // {
            //   path: 'flash',
            //   name: 'flash',
            //   component: () => import('@/views/sms/flash/index'),
            //   meta: {title: '秒杀活动列表', icon: 'sms-flash'}
            // },
            // {
            //   path: 'flashSession',
            //   name: 'flashSession',
            //   component: () => import('@/views/sms/flash/sessionList'),
            //   meta: {title: '秒杀时间段列表'},
            //   hidden:true
            // },
            // {
            //   path: 'selectSession',
            //   name: 'selectSession',
            //   component: () => import('@/views/sms/flash/selectSessionList'),
            //   meta: {title: '秒杀时间段选择'},
            //   hidden:true
            // },
            // {
            //   path: 'flashProductRelation',
            //   name: 'flashProductRelation',
            //   component: () => import('@/views/sms/flash/productRelationList'),
            //   meta: {title: '秒杀商品列表'},
            //   hidden:true
            // },
            // {
            //   path: 'coupon',
            //   name: 'coupon',
            //   component: () => import('@/views/sms/coupon/index'),
            //   meta: {title: '优惠券列表', icon: 'sms-coupon'}
            // },
            // {
            //   path: 'addCoupon',
            //   name: 'addCoupon',
            //   component: () => import('@/views/sms/coupon/add'),
            //   meta: {title: '添加优惠券'},
            //   hidden:true
            // },
            // {
            //   path: 'updateCoupon',
            //   name: 'updateCoupon',
            //   component: () => import('@/views/sms/coupon/update'),
            //   meta: {title: '修改优惠券'},
            //   hidden:true
            // },
            // {
            //   path: 'couponHistory',
            //   name: 'couponHistory',
            //   component: () => import('@/views/sms/coupon/history'),
            //   meta: {title: '优惠券领取详情'},
            //   hidden:true
            // },
            // {
            //   path: 'brand',
            //   name: 'homeBrand',
            //   component: () => import('@/views/sms/brand/index'),
            //   meta: {title: '品牌推荐', icon: 'product-brand'}
            // },
            // {
            //   path: 'new',
            //   name: 'homeNew',
            //   component: () => import('@/views/sms/new/index'),
            //   meta: {title: '新品推荐', icon: 'sms-new'}
            // },
            // {
            //   path: 'hot',
            //   name: 'homeHot',
            //   component: () => import('@/views/sms/hot/index'),
            //   meta: {title: '人气推荐', icon: 'sms-hot'}
            // },
            // {
            //   path: 'subject',
            //   name: 'homeSubject',
            //   component: () => import('@/views/sms/subject/index'),
            //   meta: {title: '专题推荐', icon: 'sms-subject'}
            // },
            // {
            //   path: 'advertise',
            //   name: 'homeAdvertise',
            //   component: () => import('@/views/sms/advertise/index'),
            //   meta: {title: '广告列表', icon: 'sms-ad'}
            // },
            // {
            //   path: 'addAdvertise',
            //   name: 'addHomeAdvertise',
            //   component: () => import('@/views/sms/advertise/add'),
            //   meta: {title: '添加广告'},
            //   hidden:true
            // },
            // {
            //   path: 'updateAdvertise',
            //   name: 'updateHomeAdvertise',
            //   component: () => import('@/views/sms/advertise/update'),
            //   meta: {title: '编辑广告'},
            //   hidden:true
            // }
        ]
    }, {
        path: '/member',
        component: Layout,
        redirect: '/member/list',
        name: 'member',
        meta: {
            title: '会员',
            icon: 'ums-admin'
        },
        children: [
            {
                path: 'list',
                name: 'list',
                component: () => import('@/views/ums/member/index'),
                meta: {
                    title: '会员列表',
                    icon: 'ums-admin'
                }
            }
        ]
    }, {
        path: '/ums',
        component: Layout,
        redirect: '/ums/admin',
        name: 'ums',
        meta: {
            title: '权限',
            icon: 'ums'
        },
        children: [
            {
                path: 'admin',
                name: 'admin',
                component: () => import('@/views/ums/admin/index'),
                meta: {
                    title: '用户列表',
                    icon: 'ums-admin'
                }
            }, {
                path: 'role',
                name: 'role',
                component: () => import('@/views/ums/role/index'),
                meta: {
                    title: '角色列表',
                    icon: 'ums-role'
                }
            }, {
                path: 'allocMenu',
                name: 'allocMenu',
                component: () => import('@/views/ums/role/allocMenu'),
                meta: { title: '分配菜单' },
                hidden: true
            }, {
                path: 'allocResource',
                name: 'allocResource',
                component: () => import('@/views/ums/role/allocResource'),
                meta: { title: '分配资源' },
                hidden: true
            }, {
                path: 'menu',
                name: 'menu',
                component: () => import('@/views/ums/menu/index'),
                meta: {
                    title: '菜单列表',
                    icon: 'ums-menu'
                }
            }, {
                path: 'addMenu',
                name: 'addMenu',
                component: () => import('@/views/ums/menu/add'),
                meta: { title: '添加菜单' },
                hidden: true
            }, {
                path: 'updateMenu',
                name: 'updateMenu',
                component: () => import('@/views/ums/menu/update'),
                meta: { title: '修改菜单' },
                hidden: true
            }, {
                path: 'resource',
                name: 'resource',
                component: () => import('@/views/ums/resource/index'),
                meta: {
                    title: '资源列表',
                    icon: 'ums-resource'
                }
            }, {
                path: 'resourceCategory',
                name: 'resourceCategory',
                component: () => import('@/views/ums/resource/categoryList'),
                meta: { title: '资源分类' },
                hidden: true
            }
        ]
    }, {
        path: '*',
        redirect: '/404',
        hidden: true
    }
]

export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js